module.exports = __webpack_public_path__ + "img/16d001-36.bb130c45.jpg";